module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.29683/images/pngs/Inbound2025.png"